import * as React from 'react';
import { css, CSSObject, Global } from '@emotion/react';
import { useHoneycombTheme } from '../hooks';
import { objectToCssVariables } from '../utils';
import { ICON_BUTTON_GLOBAL_VARIABLES, SVG_ICON_GLOBAL_VARIABLES } from '../createTheme';

export function GlobalVariables(): React.JSX.Element {
    const { theme } = useHoneycombTheme();
    const {
        breakpoints,
        interaction,
        typography,
        palette,
        zIndex,
        transitions,
        spacingUnit,
        shadows,
        radii,
        components,
    } = theme;
    const { contentMargins } = breakpoints;

    const dynamicStyles: CSSObject = {
        ':root': {
            '--hc-spacing-unit': `${spacingUnit}px`,
            '--hc-base-font-size': `${typography.baseFontSize}px`,
            '--hc-base-line-height': typography.baseLineHeight,
            ...objectToCssVariables(typography.family),
            ...objectToCssVariables(contentMargins, 'hc-content-margin-'),
            ...objectToCssVariables(palette, 'hc-color-'),
            ...objectToCssVariables(zIndex, 'hc-z-index-'),
            ...objectToCssVariables(transitions.duration, 'hc-transition-duration-', 'ms'),
            ...objectToCssVariables(transitions.easing, 'hc-transition-easing-'),
            ...objectToCssVariables(shadows, 'hc-shadow-'),
            ...objectToCssVariables(radii, 'hc-radius-'),
            ...objectToCssVariables({
                ...interaction,
                ...{ color: theme.fn.resolveFlatColorObject(interaction.color) },
            }),
            // Components
            ...objectToCssVariables(
                theme.fn.resolveRecursiveColorObject(components.themes.IconButton.colors),
                'ib-color-'
            ),
            ...objectToCssVariables(
                theme.fn.resolveRecursiveColorObject(components.themes.AlertNotice.colors),
                'an-color-'
            ),
            ...objectToCssVariables(
                theme.fn.resolveRecursiveColorObject(components.themes.DatePickerDealButton.colors),
                'dpdb-color-'
            ),
        },
    };

    return <Global styles={[css(dynamicStyles), SVG_ICON_GLOBAL_VARIABLES, ICON_BUTTON_GLOBAL_VARIABLES]} />;
}
